const getNavigationPath = (
  title,
  basePath,
  user,
  selectedStore,
  isAuthenticated
) => {
  const paths = {
    Search: `${basePath}/dashboard`,
    Butchery: `${basePath}/items`,
    "List Review": `${basePath}/dashboard`,
    "Account Info": `/users/${user?.data?.id}/profile`,
    "Contact Us": `/users/${user?.data?.id}/profile`,
    Profile: `/stores/${selectedStore?.id}/dashboard`,
    "Place Order": `/stores/${selectedStore?.id}/dashboard`,
  };

  if (title in paths) {
    return paths[title];
  }

  return isAuthenticated
    ? `${basePath}/dashboard`
    : selectedStore?.isWhiteLabel
    ? `/${selectedStore?.id}`
    : "/";
};

export default getNavigationPath;
